import { updateAuthTokens } from '@/state/auth'
import { AuthState } from '@/types/auth'

// Shared shape of the four nuke-and-reissue responses: ChangePasswordResponse,
// RevokeAllOtherSessionsResponse, Disable2faResponse, DeletePasskeyResponse.
export interface ReissuedTokenResponse {
  accessToken?: string | undefined
  refreshToken?: string | undefined
}

export interface ApplyReissuedTokensDeps {
  authState: AuthState
  setAuthState: (next: AuthState) => void
  persist: (refreshToken?: string | null) => Promise<void>
}

// The backend invalidated every session including the caller's own, then
// handed back fresh tokens. Adopt them exactly like the post-login flow does —
// persist the refresh token server-side first, then update authAtom —
// otherwise the acting tab's next request 401s on the just-revoked pair.
export async function applyReissuedTokens(
  response: ReissuedTokenResponse,
  { authState, setAuthState, persist }: ApplyReissuedTokensDeps
): Promise<boolean> {
  const { accessToken, refreshToken } = response
  if (!accessToken || !refreshToken) return false
  await persist(refreshToken)
  setAuthState(updateAuthTokens(authState, accessToken, refreshToken))
  return true
}
